export default "__VITE_ASSET__e02d089b__"